import firebase from "../firebase";

export default function({ officeId, userIds, usersMessage }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "createConversation",
        data: { officeId, userIds, usersMessage }
    });
}
